import { render, staticRenderFns } from "./MfaQrcodeDialog.vue?vue&type=template&id=5dd670f5&scoped=true&"
import script from "./MfaQrcodeDialog.vue?vue&type=script&lang=ts&"
export * from "./MfaQrcodeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd670f5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd670f5')) {
      api.createRecord('5dd670f5', component.options)
    } else {
      api.reload('5dd670f5', component.options)
    }
    module.hot.accept("./MfaQrcodeDialog.vue?vue&type=template&id=5dd670f5&scoped=true&", function () {
      api.rerender('5dd670f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/MfaQrcodeDialog.vue"
export default component.exports